'use client'

import { useEffect, useState } from 'react'
import { COMPANY_PHONE_UNFORMATTED, MESSAGE } from '@shared/constants'
export function useWhatsAppUrl() {
  const [url, setUrl] = useState(`https://api.whatsapp.com/send?phone=${COMPANY_PHONE_UNFORMATTED}&text=${encodeURIComponent(MESSAGE)}`)
  useEffect(() => {
    const isMobile = typeof window !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent)
    if (isMobile) {
      setUrl(`whatsapp://send?phone=${COMPANY_PHONE_UNFORMATTED}&text=${encodeURIComponent(MESSAGE)}`)
    }
  }, [])
  return url
} 
